import { ASSETS_RESOURCE_TYPES, AssetsUrlService } from './assets-url-service';

class VideosUrlService extends AssetsUrlService {
    constructor(domain, base) {
        super(domain, base, ASSETS_RESOURCE_TYPES.VIDEO);
    }
}

export default VideosUrlService;
